import React, { useRef, useState } from 'react';

const DeliverySearchDropdown = ({
    valueCallback = () => { },
    options,
}
) => {
    const identifier = 'deliverySearchDropdown';
    const selectRef = useRef();
    const [address, setAddress] = useState();
    const [isFocused, setIsFocused] = useState({ activeOption: false, idx: false });
    const listBoxId = `${identifier}-combobox`;

    const updateAddress = (address, e) => {
        e.stopPropagation();
        setAddress(address);
        valueCallback(address, options.find(o => o.name === address).publicId);
    };

    const setFocus = (activeOption = false, idx = false) => {
        setIsFocused({ activeOption, idx });
    }

    return (
        <ul className={'delivery-search-ul'}
            ref={selectRef}
            id={listBoxId}
            role='listbox'>
            {options?.map((option, i) => (
                <li
                    className={`delivery-search-li ${isFocused.idx === i ? 'active' : ''}`}
                    key={option.publicId}
                    id={`${identifier}-option-${i}`}
                    role='option'
                    tabIndex={-1}
                    aria-selected={option.name === address}
                    onClick={(e) => updateAddress(option.name, e)}
                    onMouseEnter={(e) => setFocus(option.name, i)}>
                    {option.name}
                    {option.type === "postal_code" &&
                        <span className={'address-label'}>View addresses</span>
                    }
                </li>
            ))}
        </ul>
    );
};

export default DeliverySearchDropdown;